import { DoctorTitle } from '../models/user/doctor-title.enum';

const enumKeyMap: Record<DoctorTitle, string> = {
  [DoctorTitle.Dr]: 'doctor-title.dr',
  [DoctorTitle.SpecialistDr]: 'doctor-title.specialist',
  [DoctorTitle.AssocProfDr]: 'doctor-title.assoc-prof',
  [DoctorTitle.ProfDr]: 'doctor-title.prof',
  [DoctorTitle.OpDr]: 'doctor-title.op',
};

const legacyStringMap: Record<string, string> = {
  Dr: 'doctor-title.dr',
  SpecialistDr: 'doctor-title.specialist',
  AssocProfDr: 'doctor-title.assoc-prof',
  ProfDr: 'doctor-title.prof',
  OpDr: 'doctor-title.op',
};

export const getDoctorTitleKey = (
  value?: DoctorTitle | number | string | null
): string | null => {
  if (value == null) return null;

  if (typeof value === 'number') {
    return enumKeyMap[value as DoctorTitle] ?? null;
  }

  const trimmed = value.toString().trim();
  if (!trimmed) return null;

  if (/^\d+$/.test(trimmed)) {
    const asNumber = Number(trimmed);
    return enumKeyMap[asNumber as DoctorTitle] ?? null;
  }

  return legacyStringMap[trimmed] ?? null;
};
